export const SCHEDULER_STATE_CHANGE_ACTION = "SCHEDULER_STATE_CHANGE";
